import { IRootState } from 'app/shared/reducers';
import { createSelector } from 'reselect';
import { StepEngineState } from './step-engine-state';

const selectStepEngineState: any = (state: IRootState) => state.stepEngine;

export const getCurrentStepIndex = createSelector(selectStepEngineState, (stepEngineStore: StepEngineState) => {
  // TODO: revoir lastRepeatableStepGroup est pas adapté à l'édition
  const currentStepIndex = stepEngineStore.stepList.findIndex(
    x => x.stepName === stepEngineStore.stepData.currentSteps[0] && x.insuredGroupIndex === stepEngineStore.stepData.currentRepeatableStepGroup
  );
  return currentStepIndex;
})
